var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloaderVisibility)?_c('PreloaderComponent'):_c('FootprintTableSingle',{attrs:{"edit-mode":true,"edit-data":_vm.editData}})}
var staticRenderFns = []

export { render, staticRenderFns }